import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { EntityDireccionesGeograficaIDEExactaState } from './entity-direcciones-geografica-ide.state';
import { DireccionGeograficaIDE } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.model';

export const getError = (
  state: EntityDireccionesGeograficaIDEExactaState
): any => state.error;

export const getIsLoading = (
  state: EntityDireccionesGeograficaIDEExactaState
): boolean => state.isLoading;

export const getDireccionExacta = (
  state: EntityDireccionesGeograficaIDEExactaState
): DireccionGeograficaIDE => {
  if (
    state.direccionGeograficaIDEExacta &&
    state.direccionGeograficaIDEExacta.length > 0
  ) {
    return state.direccionGeograficaIDEExacta[0];
  } else {
    return null;
  }
};

export const selectDireccionesGeograficaIDEExactaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.direccionesGeograficaIDEExacta
);

export const selectDireccionesGeograficaIDEExacta = createSelector(
  selectDireccionesGeograficaIDEExactaState,
  getDireccionExacta
);

// MemoizedSelector<object,any>
export const selectDireccionesGeograficaIDEExactaError = createSelector(
  selectDireccionesGeograficaIDEExactaState,
  getError
);

// MemoizedSelector<object,any>
export const selectDireccionesGeograficaIDEExactaIsLoading = createSelector(
  selectDireccionesGeograficaIDEExactaState,
  getIsLoading
);
